import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Download, Loader2 } from "lucide-react";

export const useDocPreview = () => {
  const [doc, setDoc] = useState(null);
  const show = async (url, headers, name) => {
    setDoc({ loading: true, name });
    try {
      const r = await fetch(url, { headers });
      if (!r.ok) throw new Error();
      const blob = await r.blob();
      setDoc({ name, url: URL.createObjectURL(blob), type: blob.type || "" });
    } catch { setDoc(null); toast.error("Could not open file"); }
  };
  const close = () => { if (doc?.url) URL.revokeObjectURL(doc.url); setDoc(null); };
  const dialog = (
    <Dialog open={!!doc} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-4xl" data-testid="doc-preview-dialog">
        <DialogHeader><DialogTitle>Document Preview</DialogTitle></DialogHeader>
        <div className="flex h-[65vh] items-center justify-center overflow-auto rounded-md bg-slate-100">
          {doc?.loading && <Loader2 className="h-6 w-6 animate-spin" />}
          {doc?.url && doc.type.startsWith("image/") && <img src={doc.url} alt={doc.name} className="max-h-full max-w-full object-contain" data-testid="doc-preview-image" />}
          {doc?.url && !doc.type.startsWith("image/") && (
            doc.type.includes("pdf")
              ? <iframe src={doc.url} title={doc.name} className="h-full w-full" data-testid="doc-preview-pdf" />
              : <p className="text-sm text-slate-600">Preview not available for this file type — use Download.</p>
          )}
        </div>
        <DialogFooter>
          {doc?.url && <Button asChild data-testid="doc-preview-download"><a href={doc.url} download={doc.name}><Download className="mr-1.5 h-4 w-4" />Download</a></Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
  return { show, dialog };
};
